import React, { FunctionComponent } from "react"
import PureImage from "../../components/Image/PureImage"
import { eImageVersions } from "../../definitions/Image"
import { iNews } from "../../definitions/News"
import { useImageUrl } from "../../hooks/useImageUrl"

const NewsItem: FunctionComponent<iNews> = ({
  posterVersions,
  title,
  subtitle,
}) => {
  const url =
    posterVersions && useImageUrl(eImageVersions.LIcon, posterVersions)

  return (
    <div className="content-item">
      <div className="content-image">
        <PureImage src={url} />
      </div>
      <div className="content-block">
        <h3>{title}</h3>
        <span>{subtitle}</span>
      </div>
    </div>
  )
}

export default NewsItem
